export let ROLES = /*#__PURE__*/function (ROLES) {
  ROLES["user"] = "User";
  ROLES["productAssociate"] = "Product Associate";
  ROLES["csAssociate"] = "CS Associate";
  ROLES["operationsAssociate"] = "Operations Associate";
  ROLES["salesAssociate"] = "Sales Associate";
  ROLES["logisticsAssociate"] = "Logistics Associate";
  ROLES["marketingAssociate"] = "Marketing Associate";
  ROLES["financeAssociate"] = "Finance Associate";
  ROLES["dataAssociate"] = "Data Associate";
  ROLES["csTeamLead"] = "CS Team Lead";
  ROLES["opsTeamLead"] = "Operations Team Lead";
  ROLES["productTeamLead"] = "Product Team Lead";
  ROLES["logisticsTeamLead"] = "Logistics Team Lead";
  ROLES["marketingTeamLead"] = "Marketing Team Lead";
  ROLES["salesTeamLead"] = "Sales Team Lead";
  ROLES["financeTeamLead"] = "Finance Team Lead";
  ROLES["dataTeamLead"] = "Data Team Lead";
  ROLES["customInkAdmin"] = "CustomInk Admin";
  ROLES["superAdmin"] = "Super Admin";
  ROLES["viewOnly"] = "View only";
  return ROLES;
}({});
export let POLICIES = /*#__PURE__*/function (POLICIES) {
  POLICIES["CATALOG_CATEGORIES_VIEW"] = "catalog:categories:view";
  POLICIES["CATALOG_CATEGORY_TYPES_VIEW"] = "catalog:category_types:view";
  POLICIES["CATALOG_GOODIE_CATALOG_VIEW"] = "catalog:goodie_catalog:view";
  POLICIES["CATALOG_GOODIE_CATEGORIES_VIEW"] = "catalog:goodie_categories:view";
  POLICIES["CATALOG_NOTIFICATIONS_VIEW"] = "catalog:notifications:view";
  POLICIES["CATALOG_PRODUCTS_VIEW"] = "catalog:products:view";
  POLICIES["CATALOG_SIZES_EDITOR_VIEW"] = "catalog:sizes_editor:view";
  POLICIES["CATALOG_SUPPLIERS_VIEW"] = "catalog:suppliers:view";
  POLICIES["CATALOG_REFERENCES_VIEW"] = "catalog:references:view";
  POLICIES["ORDER_ABANDONED_VIEW"] = "order_abandoned:view";
  POLICIES["ORDER_MANAGEMENT_VIEW"] = "order_management:view";
  POLICIES["ORDER_OVERVIEW_VIEW"] = "order_overview:view";
  POLICIES["ORDER_PAGE_VIEW"] = "order_page:view";
  POLICIES["INVENTORIES_CREDITS_VIEW"] = "inventories:credits:view";
  POLICIES["INVENTORIES_DISTRIBUTIONS_VIEW"] = "inventories:distributions:view";
  POLICIES["INVENTORIES_INVOICES_VIEW"] = "inventories:invoices:view";
  POLICIES["INVENTORIES_PRODUCTS_VIEW"] = "inventories:products:view";
  POLICIES["INVENTORIES_VIEW"] = "inventories:view";
  POLICIES["INVENTORY_PAGE_VIEW"] = "inventory_page:view";
  POLICIES["COMPANIES_VIEW"] = "companies:view";
  POLICIES["CUSTOM_STORE_ORDERS_VIEW"] = "custom_store:orders:view";
  POLICIES["CUSTOM_STORE_SETTINGS_VIEW"] = "custom_store:settings:view";
  POLICIES["EMAIL_SUBMISSIONS_VIEW"] = "email_submissions:view";
  POLICIES["GAMIFICATION_COMPANIES_VIEW"] = "gamification:companies:view";
  POLICIES["GAMIFICATION_SETTINGS_VIEW"] = "gamification:settings:view";
  POLICIES["KICKSTARTER_PRICES_VIEW"] = "kickstarter_prices:view";
  POLICIES["PAGE_MANAGEMENT_BROWSE_PRODUCTS_VIEW"] = "page_management:browse_products:view";
  POLICIES["PAGE_MANAGEMENT_FAQ_VIEW"] = "page_management:faq:view";
  POLICIES["PAGE_MANAGEMENT_HOME_VIEW"] = "page_management:home:view";
  POLICIES["PAGE_MANAGEMENT_PAST_WORKS_VIEW"] = "page_management:past_works:view";
  POLICIES["PLANS_VIEW"] = "plans:view";
  POLICIES["PRODUCT_SOURCING_VIEW"] = "product_sourcing:view";
  POLICIES["PROMOCODES_VIEW"] = "promocodes:view";
  POLICIES["PROMO_CAMPAIGN_EMAILS_VIEW"] = "promo_campaign_emails:view";
  POLICIES["SHIPPING_SETTINGS_VIEW"] = "shipping_settings:view";
  POLICIES["STORE_TENANT_VIEW"] = "store:tenant:view";
  POLICIES["SWAG_SPACE_APPLICATIONS_VIEW"] = "swag_space:applications:view";
  POLICIES["SWAG_SPACE_WITHDRAWALS_VIEW"] = "swag_space:withdrawals:view";
  POLICIES["SWAG_SPACE_RESELLERS_VIEW"] = "swag_space:resellers:view";
  POLICIES["USERS_VIEW"] = "users:view";
  POLICIES["DASHBOARD_VIEW"] = "dashboard:view";
  POLICIES["CATALOG_CATEGORIES_EDIT"] = "catalog:categories:edit";
  POLICIES["CATALOG_CATEGORY_TYPES_EDIT"] = "catalog:category_types:edit";
  POLICIES["CATALOG_GOODIE_CATALOG_EDIT"] = "catalog:goodie_catalog:edit";
  POLICIES["CATALOG_GOODIE_CATEGORIES_EDIT"] = "catalog:goodie_categories:edit";
  POLICIES["CATALOG_NOTIFICATIONS_EDIT"] = "catalog:notifications:edit";
  POLICIES["CATALOG_PRODUCTS_EDIT"] = "catalog:products:edit";
  POLICIES["CATALOG_REFERENCES_EMBELLISHMENT_METHODS_EDIT"] = "catalog:references:embellishment_methods:edit";
  POLICIES["CATALOG_REFERENCES_PRODUCT_ATTRIBUTES_EDIT"] = "catalog:references:product_attributes:edit";
  POLICIES["CATALOG_REFERENCES_SUPER_SPEED_EDIT"] = "catalog:references:super_speed:edit";
  POLICIES["CATALOG_REFERENCES_TAX_CODES_EDIT"] = "catalog:references:tax_codes:edit";
  POLICIES["CATALOG_SIZES_EDITOR_EDIT"] = "catalog:sizes_editor:edit";
  POLICIES["CATALOG_SUPPLIERS_EDIT"] = "catalog:suppliers:edit";
  POLICIES["ORDER_ABANDONED_HIDE_ORDER_EDIT"] = "order_abandoned:hide_order:edit";
  POLICIES["ORDER_ABANDONED_LEAD_ASSIGNEE_EDIT"] = "order_abandoned:lead_assignee:edit";
  POLICIES["ORDER_ABANDONED_LEAD_STATUS_EDIT"] = "order_abandoned:lead_status:edit";
  POLICIES["ORDER_OVERVIEW_HIDE_ORDER_EDIT"] = "order_overview:hide_order:edit";
  POLICIES["ORDER_PAGE_CANCEL_ORDER_EDIT"] = "order_page:cancel_order:edit";
  POLICIES["ORDER_PAGE_DOWNLOAD_INVOICE"] = "order_page:download_invoice";
  POLICIES["ORDER_PAGE_EMBELLISHMENT_METHOD_EDIT"] = "order_page:embellishment_method:edit";
  POLICIES["ORDER_PAGE_ITEM_STATUS_EDIT"] = "order_page:item_status:edit";
  POLICIES["ORDER_PAGE_ITEM_TIMELINE_EDIT"] = "order_page:item_timeline:edit";
  POLICIES["ORDER_PAGE_MAIN_INFO_EDIT"] = "order_page:main_info:edit";
  POLICIES["ORDER_PAGE_NOTES_EDIT"] = "order_page:notes:edit";
  POLICIES["ORDER_PAGE_SHIPPING_INFO_EDIT"] = "order_page:shipping_info:edit";
  POLICIES["ORDER_PAGE_SHIPPING_INFO_WAREHOUSE_EDIT"] = "order_page:shipping_info_warehouse:edit";
  POLICIES["ORDER_PAGE_TRANSFER_EDIT"] = "order_page:transfer:edit";
  POLICIES["ORDER_PAGE_TRANSFER_AFTER_7_DAYS_EDIT"] = "order_page:transfer_after_7_days:edit";
  POLICIES["ORDER_PAGE_VENDOR_INFO_EDIT"] = "order_page:vendor_info:edit";
  POLICIES["ORDER_PAGE_PAYMENT_RECEIVED_EDIT"] = "order_page:payment_received:edit";
  POLICIES["ORDER_PAGE_REPLACEMENT_PAYMENT_EDIT"] = "order_page:replacement_payment:edit";
  POLICIES["ORDER_PAGE_QUANTITY_EDIT"] = "order_page:quantity:edit";
  POLICIES["ORDER_PAGE_BOX_EDIT"] = "order_page:box:edit";
  POLICIES["ORDER_PAGE_ORDER_DETAILS_EDIT"] = "order_page:order_details:edit";
  POLICIES["ORDER_PAGE_ATTACHMENTS_EDIT"] = "order_page:attachments:edit";
  POLICIES["ORDER_PAGE_MOCKUPS_EDIT"] = "order_page:mockups:edit";
  POLICIES["ORDER_PAGE_RECREATE_VERTEX_TRANSACTION_EDIT"] = "order_page:recreate_vertex_transaction:edit";
  POLICIES["ORDER_PAGE_SENDOSO_SHIP_NOTICE_EDIT"] = "order_page:sendoso:ship_notice:edit";
  POLICIES["ORDER_PAGE_READY_FOR_DISTRIBUTION_EDIT"] = "order_page:ready_for_distribution:edit";
  POLICIES["ORDER_PAGE_UNDO_ITEM_COMPLETED_STATUS_EDIT"] = "order_page:undo_item_completed_status:edit";
  POLICIES["INVENTORIES_CREDITS_EDIT"] = "inventories:credits:edit";
  POLICIES["INVENTORIES_DISTRIBUTIONS_TRACKING_EDIT"] = "inventories:distributions:tracking:edit";
  POLICIES["INVENTORIES_DISTRIBUTIONS_ORDER_NUMBER_EDIT"] = "inventories:distributions:order_number:edit";
  POLICIES["INVENTORIES_DISTRIBUTIONS_ADDRESS_EDIT"] = "inventories:distributions:address:edit";
  POLICIES["INVENTORIES_DISTRIBUTIONS_TRIGGER"] = "inventories:distributions:trigger";
  POLICIES["INVENTORIES_DISTRIBUTIONS_CANCEL"] = "inventories:distributions:cancel";
  POLICIES["PRODUCT_SOURCING_EDIT"] = "product_sourcing:edit";
  POLICIES["INVENTORIES_PRODUCTS_FLAT_RATE_EDIT"] = "inventories:products:flat_rate:edit";
  POLICIES["INVENTORIES_PRODUCTS_QUANTITY_EDIT"] = "inventories:products:quantity:edit";
  POLICIES["INVENTORIES_PRODUCTS_WAREHOUSE_IMAGE_EDIT"] = "inventories:products:warehouse_image:edit";
  POLICIES["INVENTORIES_TURNAROUND_TIME_EDIT"] = "inventories:turnaround_time:edit";
  POLICIES["INVENTORY_PAGE_CREDITS_BALANCE_EDIT"] = "inventory_page:credits_balance:edit";
  POLICIES["INVENTORY_PAGE_FREEZE_ENABLED_EDIT"] = "inventory_page:freeze_enabled:edit";
  POLICIES["INVENTORY_PAGE_IS_FROZEN_EDIT"] = "inventory_page:is_frozen:edit";
  POLICIES["INVENTORY_PAGE_PAYMENT_SETTINGS_EDIT"] = "inventory_page:payment_settings:edit";
  POLICIES["INVENTORY_PAGE_STORAGE_FEE_ACCRUAL_EDIT"] = "inventory_page:storage_fee_accrual:edit";
  POLICIES["INVENTORY_PAGE_STORAGE_FEE_REMINDERS_EDIT"] = "inventory_page:storage_fee_reminders:edit";
  POLICIES["COMPANIES_PAYMENT_TERMS_EDIT"] = "companies:payment_terms:edit";
  POLICIES["COMPANIES_WAREHOUSE_EDIT"] = "companies:warehouse:edit";
  POLICIES["COMPANIES_IS_COMPANY_EDIT"] = "companies:is_company:edit";
  POLICIES["COMPANIES_MANUAL_ORDER_APPROVAL_EDIT"] = "companies:manual_order_approval:edit";
  POLICIES["CUSTOM_STORE_ORDERS_EDIT"] = "custom_store:orders:edit";
  POLICIES["CUSTOM_STORE_SETTINGS_EDIT"] = "custom_store:settings:edit";
  POLICIES["EMAIL_SUBMISSIONS_EDIT"] = "email_submissions:edit";
  POLICIES["GAMIFICATION_SETTINGS_EDIT"] = "gamification:settings:edit";
  POLICIES["KICKSTARTER_PRICES_EDIT"] = "kickstarter_prices:edit";
  POLICIES["PAGE_MANAGEMENT_BROWSE_PRODUCTS_EDIT"] = "page_management:browse_products:edit";
  POLICIES["PAGE_MANAGEMENT_FAQ_EDIT"] = "page_management:faq:edit";
  POLICIES["PAGE_MANAGEMENT_HOME_EDIT"] = "page_management:home:edit";
  POLICIES["PAGE_MANAGEMENT_PAST_WORKS_EDIT"] = "page_management:past_works:edit";
  POLICIES["PLANS_EDIT"] = "plans:edit";
  POLICIES["PROMOCODES_EDIT"] = "promocodes:edit";
  POLICIES["SHIPPING_SETTINGS_EDIT"] = "shipping_settings:edit";
  POLICIES["STORE_TENANT_EDIT"] = "store:tenant:edit";
  POLICIES["SWAG_SPACE_APPLICATIONS_EDIT"] = "swag_space:applications:edit";
  POLICIES["SWAG_SPACE_WITHDRAWALS_EDIT"] = "swag_space:withdrawals:edit";
  POLICIES["USERS_LOGIN_EDIT"] = "users:login:edit";
  POLICIES["USERS_PAYMENT_TERMS_EDIT"] = "users:payment_terms:edit";
  POLICIES["USERS_USER_EDIT"] = "users:user:edit";
  POLICIES["USERS_ADMIN_EDIT"] = "users:admin:edit";
  POLICIES["CHECKOUT_REPLACEMENT_ORDER_EDIT"] = "checkout:replacement_order:edit";
  POLICIES["CHECKOUT_REPLACEMENT_PERCENT_EDIT"] = "checkout:replacement_percent:edit";
  POLICIES["CHECKOUT_DUMMY_ORDER_EDIT"] = "checkout:dummy_order:edit";
  POLICIES["ORDER_PRIORITY_EDIT"] = "order_priority:edit";
  POLICIES["ORDER_OPS_ASSOCIATE_EDIT"] = "order_ops_associate:edit";
  POLICIES["ORDER_CS_ASSOCIATE_EDIT"] = "order_cs_associate:edit";
  return POLICIES;
}({});